import { Container } from "@material-ui/core";
import { useLocation } from "react-router";
import Page2ItemSettings from "./ProductionCreateOrderSelect/Page2ItemSettings/Page2ItemSettings";

const ProductionDetails = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const id = query.get("id");

  return (
    <Container maxWidth="xl">
      <Page2ItemSettings id={id} />
    </Container>
  );
};

export default ProductionDetails;
